import { render, staticRenderFns } from "./ProviderInstructions.vue?vue&type=template&id=1b162eb4&scoped=true&"
import script from "./ProviderInstructions.vue?vue&type=script&lang=js&"
export * from "./ProviderInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ProviderInstructions.vue?vue&type=style&index=0&id=1b162eb4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b162eb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b162eb4')) {
      api.createRecord('1b162eb4', component.options)
    } else {
      api.reload('1b162eb4', component.options)
    }
    module.hot.accept("./ProviderInstructions.vue?vue&type=template&id=1b162eb4&scoped=true&", function () {
      api.rerender('1b162eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LinkInstructions/ProviderInstructions.vue"
export default component.exports